export const PARENTS_ROUTE = {
  ADD_CHILD: {
    name: 'addchild',
    route(): string[] {
      return [...PARENTS_ROUTE.route(), this.name];
    }
  },
  ADD_EXISTING_CHILD: {
    name: 'addexistingchild',
    route(): string[] {
      return [...PARENTS_ROUTE.route(), this.name];
    }
  },
  CREATE_CHILD_ACCOUNT: {
    name: 'createchildaccount',
    route(): string[] {
      return [...PARENTS_ROUTE.route(), this.name];
    }
  },
  DEFAULT: '',
  HELP_CENTER: {
    name: 'helpcenter',
    route(): string[] {
      return [...PARENTS_ROUTE.route(), this.name];
    }
  },
  HOME: {
    name: 'home',
    route(): string[] {
      return [...PARENTS_ROUTE.route(), this.name];
    }
  },
  name: 'parents',
  route(): string[] {
    return ['/' + this.name];
  },
  SETTINGS: {
    name: 'settings',
    route(): string[] {
      return [...PARENTS_ROUTE.route(), this.name];
    }
  },
  SUBSCRIPTIONS: {
    name: 'subscriptions',
    route(): string[] {
      return [...PARENTS_ROUTE.route(), this.name];
    }
  }
};
